import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AccountInfo, AuthenticationResult, InteractionStatus } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { BuildListService } from './buildlist.service';
import { IBuildList } from '../shared/buildList';
import * as auth from '../auth-config.json';
import { Account } from '../shared/account';

@Component({
  selector: 'app-buildlist',
  templateUrl: './buildlist.component.html',
  styleUrls: ['./buildlist.component.css']
})
export class BuildlistComponent implements OnInit {

  public buildLists: IBuildList[];
  public buildList: IBuildList;
  public selId: string;
  loginDisplay = false;
  public message: string = "You must login to view this page.";

  constructor(private data: BuildListService, private spinner: NgxSpinnerService, private router: Router,
      private fb: FormBuilder, private authService: MsalService, private msalBroadcastService: MsalBroadcastService) {

  }

  ngOnInit() {

    this.handleSecurity();

    this.data.loadBuildLists()
      .subscribe(data => {
        this.buildLists = data;
      });
  }

  handleSecurity() {

    this.authService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult) => {
        if (result) {
          this.authService.instance.setActiveAccount(result.account);
          console.log(result);
        }
        // Sets login display when using redirects
        this.setLoginDisplay();
      },
      error: (error) => console.log(error)
    });

    // Sets login display when using popups
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });
  }

  setLoginDisplay() {

    let allowedRoles = [auth.roles.BuildManager, auth.roles.Reader];

    let accounts: AccountInfo[] = this.authService.instance.getAllAccounts();
    let account: Account = accounts[0];

    this.loginDisplay = accounts.length > 0;

    if (this.loginDisplay && !allowedRoles.includes(account.idTokenClaims?.roles[0])) {
      this.loginDisplay = false;
      this.message = 'You do not have the correct permissions to view this page.';
    }
  }

  openBuildList(id: string) {

      if (id != "0") {
        this.selId = id;
        this.spinner.show();
        this.refreshList(null); //get latest state of all build items
        //this.data.getBuildListById(id)
        //.subscribe(result => {
        //  this.buildList = result;
        //  this.spinnerService.hide();
        //})
      }
  }

  refreshList(arg: any) {
    this.data.refreshState(this.selId)
      .subscribe(result => {
        this.refreshGrid();
      });
  }

  refreshGrid() {
    this.data.getBuildListById(this.selId)
      .subscribe(result => {
        this.buildList = result;
        this.spinner.hide();
      })
  }

}
